import "@mdi/font/css/materialdesignicons.css";
import "roboto-fontface/css/roboto/sass/roboto-fontface.scss";
import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify as any);

export default new (Vuetify as any)({
  icons: {
    iconfont: "mdi"
  }
});
